/**
 * Entry für Vite. Lädt die CSS-Pipeline (Tailwind v4 + Custom Components)
 * und das Frontend-JS (Mobile-Menü, Accordion).
 *
 * Phosphor Icons werden NICHT hier importiert — sie liegen statisch unter
 * Resources/Public/Fonts/phosphor/ und werden separat via setup.typoscript
 * geladen. Grund: Vite/Lightning CSS verschluckte die Unicode-Escape-
 * Sequenzen und die @font-face-URLs passten nicht zur TYPO3-Asset-Pipeline.
 */
import './main.css'
import { initMobileMenu } from './js/mobileMenu'
import { initAccordion } from './js/accordion'
import { initSpeakerGrid } from './js/speakerGrid'

document.addEventListener('DOMContentLoaded', () => {
    initMobileMenu()
    initAccordion()
    initSpeakerGrid()
})
